import { Action, AnyAction, combineReducers, configureStore, Reducer, ThunkAction } from '@reduxjs/toolkit';
import productReducer from 'src/store/product/productSlice';
import productSearchReducer from 'src/store/product-search/productSearchSlice';
import homeDisplaySlice from './store/home-display/homeDisplaySlice';
import homeDisplayCategorySearchReducer from './store/home-display-category-search/homeDisplayCategorySearchSlice';
import snackbarSlice from './store/snackbarMessage/snackbarSlice';
import productVideoSlice from './store/product-video/productVideoSlice';
import bannerSlice from './store/banner/bannerSlice';
import etcSlice from './store/etc/etcSlice';
import deliveryCompanySlice from './store/delivery-company/deliveryCompanySlice';
import giftSlice from './store/gift/giftSlice';
import { StoreState } from './admin-entity/interface/store/store-state.interface';
import progressSlice from './store/progress/progressSlice';
import settingSlice from './store/setting/settingSlice';
import modalSlice from './store/modal/modalSlice';
import calculationSlice from './store/calculation/calculationSlice';
import invoiceSlice from './store/invoice/invoiceSlice';
import productTabSearchSlice from './store/product-tab-search/productTabSearchSlice';
import pointSlice from './store/point/pointSlice';
import userSlice from './store/user/userSlice';
import statisticsSlice from './store/statistics/statisticsSlice';
import orderSlice from './store/order/orderSlice';
import productFundingSlice from './store/product/funding/productFundingSlice';
import productTagSlice from './store/product-tag/productTagSlice';
import globalBanSlice from './store/globalBan/globalBanSlice';
import liveSlice from './store/live/liveSlice';
import faqSlice from './store/faq/faqSlice';
import liveProductSlice from './store/live-product/liveProductSlice';
import liveEndSlice from './libs/src/store/liveEnd/liveEndSlice';

export const rootReducer = combineReducers({
    product: productReducer,
    homeDisplayCategorySearchReducer: homeDisplayCategorySearchReducer,
    productSearch: productSearchReducer,
    homeDisplay: homeDisplaySlice,
    snackbar: snackbarSlice,
    productVideo: productVideoSlice,
    banner: bannerSlice,
    deliveryCompanySlice: deliveryCompanySlice,
    etc: etcSlice,
    gift: giftSlice,
    progress: progressSlice,
    setting: settingSlice,
    modal: modalSlice,
    calculation: calculationSlice,
    invoice: invoiceSlice,
    productTabSearch: productTabSearchSlice,
    point: pointSlice,
    user: userSlice,
    statistics: statisticsSlice,
    order: orderSlice,
    funding: productFundingSlice,
    productTag: productTagSlice,
    globalBan: globalBanSlice,
    live: liveSlice,
    faq: faqSlice,
    liveProduct: liveProductSlice,
    liveEnd: liveEndSlice,
}) as Reducer<StoreState, AnyAction>;

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
});

// export type AppStore = ReturnType<typeof store>;
export type AppState = ReturnType<(typeof store)['getState']>;
export type AppDispatch = (typeof store)['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;
